/* jslint browser: true */
import React, { Component } from 'react';
import PropTypes            from 'prop-types';
import Collapsible          from 'react-collapsible';

import PageBlockTitle       from './PageBlockTitle';
import AnnexeBlockBody      from './AnnexeBlockBody';

/**
 * Bloc quelconque (de type annexe ou programme)
 */
class PageBlock extends Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            block: this.props.block,
            isBlockOpen: this.props.isBlockOpen
        };
        
        this.onOpening          = this.onOpening.bind(this);
        this.onClose            = this.onClose.bind(this);
        this.updateBlockTitle   = this.updateBlockTitle.bind(this);
    }
    
    /**
     * Exécuté au moment de l'ouverture de l'accordéon
     */
    onOpening(){ 
        this.setState({
            isBlockOpen: true
        });
        this.props.closeOtherBlocks(this.state.block.id_annexe);
    }
    
    /**
     * Exécuté au moment de la fermeture de l'accordéon
     */
    onClose(){
        this.setState({
            isBlockOpen: false
        });
    }
    
    /**
     * Change le titre du bloc
     * @param {type} newTitle le nouveau titre du bloc
     */
    updateBlockTitle(newTitle){
        this.setState({
            block: {...this.state.block, titre: newTitle}
        });
    }
    
    render(){
        const block = this.state.block;

        return (<div className="page-block">
           
            <Collapsible 
                triggerDisabled={block.semaine !== 0} 
                open={this.props.isBlockOpen}
                onOpening={this.onOpening} 
                onClose={this.onClose} 
                trigger={<PageBlockTitle block={block}></PageBlockTitle>}>
                {block.semaine === 0 && <AnnexeBlockBody block={block} moveBlock={this.props.moveBlock} removeBlock={this.props.removeBlock} updateBlockTitle={this.updateBlockTitle} isBlockOpen={this.state.isBlockOpen}></AnnexeBlockBody>}
            </Collapsible>
            
        </div>);
    }
}

PageBlock.propTypes = { block: PropTypes.object, isBlockOpen: PropTypes.bool };

export default PageBlock;


// WEBPACK FOOTER //
// ./src/components/annexes/PageBlock.js